
<div>
    <!--Loading Placeholder-->
    <div *ngIf="isLoading">
        <app-table-loading
        [rows]="loadingTemplateRows"
        >
        </app-table-loading>
    </div>
    <div [hidden]="isLoading">
        <div class="ops-table">
            <ng-content></ng-content>
        </div>
    </div>
</div>